module.exports = __webpack_public_path__ + "static/media/youtube_channelId.6095ee68.png";